import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { useLoading } from "../../Context/LoadingProvider";
import {patrollerService} from "../../Api/Services/PatrollerService";
import { TickFilledIcon } from "../../Components/Icons/TickFilledIcon";

interface CheckHistoryProps {
  subTitle?: string;
}

const CheckHistory: React.FunctionComponent<CheckHistoryProps> = ({subTitle}) => {
  const { t } = useTranslation();
  const { startLoading, finnishLoading } = useLoading();
  const {
    setSubTitle,
    rider,
      setShowProfileInfo
  } = useOutletContext<RiderProfileLayoutContextInterface>();

  const [history, setHistory] = useState<any[]>([]);

  setShowProfileInfo(true);
  const fetchHistory = () => {
    startLoading("get-history");
    patrollerService
      .listHistory(rider.riderId)
      .then((historyItems) => {
        setHistory(historyItems);
      })
      .finally(() => {
        finnishLoading("get-history");
      });
  };

  useEffect(() => {
    fetchHistory();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSubTitle();
  }, [t, setSubTitle]);

  setSubTitle(t('T-Patroller Actions History'));

  const laravelDateTimeToDMY = (laravelDateTime: string) => {
    var parts = laravelDateTime.split(' ');
    var datePart = parts[0];

    var dateParts = datePart.split('-');
    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];

    return day + '-' + month + '-' + year;
  }

  return (
          <>
            {subTitle && <div className="heading mb-4">{subTitle}</div>}

            <div className="flex flex-col gap-4">
              {history.map((historyItem, index) => {
                  return <div className="card" key={index} style={{paddingBottom: "0"}}>
                      <div  className="flex gap-2 items-center">
                        <div style={{color: "rgba(31, 181, 41, 1)"}}><TickFilledIcon /></div>
                        <div>
                          {historyItem.message}
                        </div>
                      </div>

                      <table className="dp-table">
                        <tbody>
                          <tr>
                            <td>{t('T-Patroller')}</td>
                            <td className="dp-table__marked">{historyItem.patroller_name}</td>
                          </tr>
                          <tr>
                            <td>{t('Date')}</td>
                            <td className="dp-table__marked">{laravelDateTimeToDMY(historyItem.created_at).replaceAll('-', '/')}</td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              })}
            </div>
          </>
  );
};

export default CheckHistory;
